import { useContext } from 'react';

import { userGlobalStoreCtx } from 'src/stores/user';

import AuthError from './AuthError';
import SystemError from './SystemError';

const AppError = () => {
  const { userDataReq } = useContext(userGlobalStoreCtx);

  if (userDataReq.state === 'rejected') {
    return <AuthError />;
  }

  return <SystemError />;
};

export default AppError;
